/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ControlMappingsListData {
    getFixupPrototypeFunction() { return ControlMappingsListData.fixupPrototype; }

    static newInstance(model: Partial<ControlMappingsListData>): ControlMappingsListData {
        let obj = Object.assign(new ControlMappingsListData(), model);
        ControlMappingsListData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ControlMappingsListData>): ControlMappingsListData {
        if (!model) return null;
        return ControlMappingsListData.newInstance(<ControlMappingsListData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ControlMappingsListData) {
        if (!obj) return;

        models.ControlMappingsListData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ControlMappingsListData): boolean {
        Object.setPrototypeOf(obj, ControlMappingsListData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * attributes of controls which dictate actions specific to corestack
     */
    control_action_attributes: any;

    /**
     * security risk family that control belongs to
     */
    control_family: string;

    /**
     * the unique identifier of the control in the tenant
     */
    compliance_control_uri: string;

    /**
     * attributes associated with the controls unique to the standard
     */
    control_attributes: any;

    /**
     * severity of control data
     */
    severity: string;

    /**
     * attributes of controls which dictate actions specific to corestack
     */
    policy_mappings: any;

    /**
     * the compliance standard associated with the control
     */
    compliance_uri: string;

    /**
     * name of the control
     */
    control_name: string;

    /**
     * unique DB id of the control
     */
    id: any;

}
